export default __webpack_public_path__ + "static/media/subscribed-user-white.6f081f73.svg";